import React from 'react';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';

import { FlexBoxColumn } from '@ecp/common/src/layouts/flex/styled';
import { Spacing } from '@ecp/common/src/layouts/Spacing';
import { TextBox } from '@ecp/common/src/text/TextBox';
import Button from '@ecp/common/src/components/button/bo/Button';
import { ReactComponent as ErrorIcon } from '@ecp/common/src/assets/icon/icon__error-not-found.svg';

const NotFoundErrorPage = () => {
  const navigate = useNavigate();

  return (
    <Container>
      <ErrorIcon />
      <Spacing top={'20px'} />
      <TextBox size={'16px'} weight={'500'} color={'#333333'}>
        요청하신 페이지를 찾을 수 없습니다.
      </TextBox>
      <Spacing top={'50px'} />
      <Button type={'Primary'} onClick={() => navigate('/')}>
        메인으로 가기
      </Button>
    </Container>
  );
};

const Container = styled(FlexBoxColumn)`
  height: 100vh;
  justify-content: center;
`;

export default NotFoundErrorPage;
